import { resourceType, cate, sliceUpload, mergeSlice, resourceAdd } from '@/utils/apis.js'
import  Upload from '@/utils/slice_upload';
import el from "element-ui/src/locale/lang/el";
export default {
	data() {
		return {
			//分类列表
			specializedValue: [],
			specializedList: [],
			keyObj: {
				label: 'name',
				value: 'id',
				children: 'children',
			},
			//资源类型列表
			resourcesType: [],
			resourcesValue: [],
			libType: 0,
			//要上传的资源列表
			resourcesUploadTable: [],
			dialogUploadResources: false,
			supportTypeDesc: '',
			acceptFormat: '.pptx, .doc, .docx, .pdf, .mp4',
			uploadIndex: 0,
			materialTypeId: 0,
			// errorInput: 0
			chunkSize: 10*1024*1024,
			resourceField: {
				label: 'name',
				value: 'id'
			}
		}
	},
	created() {
		this.getSpecializedList();
		this.getResourcesType();
	},
	methods: {
		changeResourcesClass(value) {
			// console.log(value)
		},
		//获取资源分类列表
		getSpecializedList() {
			let param = {
				type: '2'
			}
			cate(param).then((res) => {
				this.specializedList = res.data;
			}, (err) => {
				console.log(err);
			})
		},
		//获取资源类型列表
		getResourcesType() {
			resourceType().then((res) => {
				this.resourcesType = res.data;
			}, (err) => {
				console.log(err);
			})
		},
		uploadFiles() {
			if (this.resourcesUploadTable.length === 0) {
				this.$message.warning('请选择上传的文件');
				return;
			}
			for (let i=0; i < this.resourcesUploadTable.length; i++) {
				let value = this.resourcesUploadTable[i];
				if (value.pdf_percent !== undefined && value.pdf_file === null) {
					this.$message.warning(`${value.file_name}需要再上传将文件转为pdf格式类型文件`);
					return;
				}
				if (value.path && value.preview_path) {
					continue;
				}
				this.initUpload(value);
			}
		},
		pdfUpload(evt,index) {
			let file = evt.target.files[0];
			this.resourcesUploadTable[index].pdf_file = file;
			this.resourcesUploadTable[index].preview_path = '';
			this.resourcesUploadTable[index].pdf_percent = 0;
			document.querySelector(`#pdf_${index}`).value = '';
		},
		initUpload(element) {
			if (element.pdf_file) {
				if (!element.path) {
					element.file_upload = new Upload(element.file, this.chunkSize, sliceUpload);
					this.uploadSlice(0, element);
				}
				if (!element.preview_path) {
					element.file_pdf_upload = new Upload(element.pdf_file, this.chunkSize, sliceUpload);
					this.uploadPdfSlice(0, element);
				}
			} else {
				if (element.path) {
					return;
				}
				element.file_upload = new Upload(element.file, this.chunkSize, sliceUpload);
				this.uploadSlice(0, element);
			}
		},
		uploadSlice(index, element) {
			if (index === element.file_upload.total_block_num && element.file_upload.total_block_num !== 1) {
				//合并分片
				this.mergeSlice(element);
				return;
			}
			element.file_upload.uploadSlice(index).then(res => {
				if (res.code === 200) {
					if (res.data.is_slice) { //is_slice 为true则为分片上传，后面需要合并分片,若为false则无须分片，或者文件大小<分片尺寸，直接上传就行
						element.process = Math.round((index/element.file_upload.total_block_num)*100);
						this.uploadSlice(++index, element);
					} else {
						element.process = 100;
						element.path = res.data.src;
						if (!element.file_pdf_upload) {
							element.preview_path = res.data.src;
						}
					}

				}
			});
		},
		uploadPdfSlice(index, element) {
			if (index === element.file_pdf_upload.total_block_num && element.file_pdf_upload.total_block_num !== 1) {
				//合并分片
				this.mergePdfSlice(element);
				return;
			}
			element.file_pdf_upload.uploadSlice(index).then(res => {
				if (res.code === 200) {
					if (res.data.is_slice) { //is_slice 为true则为分片上传，后面需要合并分片,若为false则无须分片，或者文件大小<分片尺寸，直接上传就行
						element.pdf_percent = Math.round((index/element.file_pdf_upload.total_block_num)*100);
						this.uploadPdfSlice(++index, element);
					} else {
						element.pdf_percent = 100;
						element.preview_path = res.data.src;
					}
				}
			});

		},
		mergeSlice(element) {
			mergeSlice({flag: element.file_upload.file_tmp, slice_size: element.file_upload.block_size}).then(res => {
				if (res.code === 200) {
					element.process = 100;
					element.path = res.data.src;
					if (!element.file_pdf_upload) {
						element.preview_path = res.data.src;
					}
				}
			});
		},
		mergePdfSlice(element) {
			mergeSlice({flag: element.file_pdf_upload.file_tmp, slice_size: element.file_pdf_upload.block_size}).then(res => {
				if (res.code === 200) {
					element.pdf_percent = 100;
					element.preview_path = res.data.src;
				}
			});

		},
		//保存
		saveResources() {
			if (this.specializedValue.length === 0) {
				this.$message.warning('请选择分类');
				return;
			}
			if (this.resourcesValue.length === 0) {
				this.$message.warning('请选择类型');
				return;
			}
			if (this.resourcesUploadTable.length === 0) {
				this.$message.warning('请上传资源');
				return;
			}
			let formData = {};
			formData.category_id = this.specializedValue[this.specializedValue.length - 1];
			formData.type = this.resourcesValue[this.resourcesValue.length - 1];
			formData.resources = [];
			for (let i=0; i < this.resourcesUploadTable.length; i++) {
				let element = this.resourcesUploadTable[i];
				if (!element.path) {
					this.$message.warning(`${element.file_name}还未上传，请点击上传`);
					return;
				}
				if (element.pdf_file !== undefined && element.pdf_file === null) {
					this.$message.warning(`${element.file_name}还未上传pdf格式的预览文件，请点击右侧的上传pdf按钮`);
					return;
				}
				if (element.pdf_file && element.preview_path.length === 0) {
					this.$message.warning(`${element.file_name}的pdf格式文件还未上传，请点击下面的上传按钮`);
					return;
				}
				if (element.title.trim().length === 0) {
					this.$message.warning(`请填写${element.file_name}文件的标题`);
					return;
				}
				if (element.intro.trim().length === 0) {
					this.$message.warning(`请填写${element.file_name}文件的简介`);
					return;
				}
				formData.resources.push({
					title: element.title,
					intro: element.intro,
					page_time: element.page_time,
					path: element.path,
					preview_path: element.preview_path
				});
			}
			resourceAdd(formData).then(res => {
				if (res.code === 200) {
					this.$message({
						message: res.msg,
						type: "success",
						duration: 3000,
						onClose: () => {
							this.dialogUploadResources = false;
							this.$emit('materialMethod', true);
						}
					});
				}
			});
		},
		chooseFile() {
			let fileList = [];
			let obj = document.getElementById("file").files;
			for (let i = 0; i < obj.length; i++) {
				let _file = obj[i];
				let file_name = _file.name;
				let tmp =[];
				[...tmp] = file_name.split('.');
				let ext = tmp[tmp.length - 1];
				let title = tmp.length > 2 ? tmp.slice(0, tmp.length - 1).join('.') : tmp[0];
				let cell = {
					file: _file,
					file_name,
					process: 0,
					ext,
					title,
					intro: title,
					page_time: 0,
					file_upload: null,
					path: '',
					preview_path: ''
				};
				if (['docx','doc','xlsx','xls','ppt','pptx'].indexOf(cell.ext.toLowerCase()) !== -1) {
					cell.pdf_file = null;
					cell.pdf_percent = 0;
					cell.file_pdf_upload = null;
				}
				this.resourcesUploadTable.push(cell);
			}
			this.$refs.fileEvt.value = null;
		},
		deleteUploadRow(index) {
			this.resourcesUploadTable.splice(index, 1);
		},
		supportFunc() {
			if (this.resourcesValue.length === 0 ) {
				this.acceptFormat = '.pptx, .doc, .docx, .pdf, .mp4';
				this.supportTypeDesc = '';
				return;
			}
			let type = Number(this.resourcesValue[this.resourcesValue.length - 1]);
			switch (type) {
				case 1:
				case 6:
				case 8:
					this.supportTypeDesc = '*支持上传资源格式：pptx/ppt/pdf';
					this.acceptFormat = '.pptx, .ppt, .pdf';
					break;
				case 2:
				case 10:
					this.supportTypeDesc = '*支持上传资源格式：doc/docx/pdf';
					this.acceptFormat = '.doc, .docx, .pdf';
					break;
				case 3:
					this.supportTypeDesc = '*支持上传资源格式：mp4';
					this.acceptFormat = '.mp4';
					break;
				case 4:
				case 9:
					this.supportTypeDesc = '*支持上传资源格式：mp4';
					this.acceptFormat = '.mp4';
					break;
				case 5:
				case 7:
					this.supportTypeDesc = '*支持上传资源格式：doc/docx/pdf/mp4/rar/zip';
					this.acceptFormat = '.doc, .docx, .pdf, .mp4, .rar, .zip';
					break;
			}
		},
		onClose() {
			this.specializedValue = [];
			this.resourcesValue = '';
			this.resourcesUploadTable = [];
			this.supportTypeDesc = '';
			this.acceptFormat = '.pptx, .doc, .docx, .pdf, .mp4';
		}
	}
}